import { render } from "./DeliveryAddress.vue?vue&type=template&id=60daee3e&scoped=true"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"

import "./DeliveryAddress.vue?vue&type=style&index=0&id=60daee3e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60daee3e"]])

export default __exports__